import type { CSSObjectWithLabel, GroupBase, StylesConfig } from 'react-select';
import type { OptionType } from './components';

/**
 * Custom styles for react-select AsyncSelect
 */
export const selectStyles: StylesConfig<OptionType, true, GroupBase<OptionType>> = {
  control: (base, state) => ({
    ...base,
    minHeight: 'var(--dfy-select-h)',
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    borderColor: state.isDisabled ? '#dbdde4' : state.isFocused ? '#a6b9fb' : '#dbdde4 ',
    ':hover': {
      borderColor: state.isDisabled ? '#dbdde4' : state.isFocused ? '#a6b9fb' : '#dbdde4 ',
    },
    boxShadow: 'none',
    alignItems: 'center',
    flexWrap: 'wrap',
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
  }),
  valueContainer: (base): CSSObjectWithLabel => ({
    ...base,
    padding: '6px 14px',
    flexWrap: 'wrap',
  }),
  indicatorsContainer: (base): CSSObjectWithLabel => ({
    ...base,
    paddingRight: 14,
  }),
  dropdownIndicator: (base): CSSObjectWithLabel => ({
    ...base,
    padding: 0,
  }),
  multiValue: (base): CSSObjectWithLabel => ({
    ...base,
    backgroundColor: '#E5E7EB',
    borderRadius: 6,
  }),
  multiValueLabel: (base): CSSObjectWithLabel => ({
    ...base,
    color: '#111827',
    fontWeight: 500,
  }),
  multiValueRemove: (base): CSSObjectWithLabel => ({
    ...base,
    ':hover': { backgroundColor: 'transparent' },
  }),
  placeholder: (base, state): CSSObjectWithLabel => ({
    ...base,
    color: state?.isDisabled ? '#ccced3' : '#6B7280',
    fontSize: 14,
  }),
  input: (base): CSSObjectWithLabel => ({ ...base, margin: 0 }),
  menu: (base): CSSObjectWithLabel => ({ ...base, borderRadius: 8, overflow: 'hidden' }),
  option: (base, state): CSSObjectWithLabel => ({
    ...base,
    backgroundColor: state.isFocused ? '#F3F4F7' : undefined,
    ':hover': {
      backgroundColor: '#F3F4F7',
    },
  }),
  menuPortal: (base): CSSObjectWithLabel => ({ ...base, zIndex: 99999 }),
  loadingMessage: (base): CSSObjectWithLabel => ({
    ...base,
    color: '#6B7280',
    fontSize: 14,
    padding: '16px',
  }),
};
